import { ItemInfoType, UserListEntity } from "interfaces";
import { dateFormat, getPhone } from "utils";

export const getColumns = (data: UserListEntity): Array<ItemInfoType> => {
  const { email, phone, statusDate, attorneyExpirationDate, attorneyDate, attorney, position } = data;
  return [
    {
      label: "Номер телефона",
      text: getPhone(phone),
    },
    {
      label: "Email",
      text: `${email}`,
    },
    attorney && {
      label: "Номер доверенности",
      text: attorney,
    },
    attorneyDate &&
      attorneyExpirationDate && {
        label: "Срок действия доверенности",
        text: `${dateFormat(attorneyDate)} - ${dateFormat(attorneyExpirationDate)}`,
      },
    {
      label: "Дата смены статуса",
      text: dateFormat(statusDate, true),
    },
    position && {
      label: "Должность",
      text: `${position}`,
    }
  ].filter((c) => !!c);
};
